import * as CardCrawl from "@ravalmatic/cardcrawl-engine";
import { GameVars } from "../../../../GameVars";
import { BoardContainer } from "../../BoardContainer";
import { EventType } from "../../../../Types";
import { Card } from "../Card";
import { Utils } from "../../../../utils/Utils";
import { CoinsEffect } from "./CoinsEffect";
import { HeartEffect } from "./HeartEffect";
import { AudioManager } from "../../../../AudioManager";

export class FX {

    public static readonly DELAY = 500;

    public static moveTo(card: Card, p: {x: number, y: number, angle: number}, duration: number, delay: number, onComplete?: () => void, onCompleteScope?: any): void {

        if (card.cardData.type === CardCrawl.CardType.ENEMY) {
            duration *= .25;
            delay *= .25;
        }

        card.scene.tweens.add({
            targets: card,
            x: p.x,
            y: p.y,
            angle: p.angle,
            scaleX: 1, 
            scaleY: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: duration,
            delay: delay,
            onComplete: function(): void {
                FX.flash(card, onComplete, onCompleteScope);
            },
            onCompleteScope: this
        });
    }

    public static disappear(card: Card): void {

        if (card.cardData.uiData.performedAction === CardCrawl.ActionType.EMPTIED || card.cardData.uiData.performedAction === CardCrawl.ActionType.SELL_CARD) {

            FX.addCoinsHeartsEffect(card, true);

        } else if (
            card.cardData.uiData.performedAction === CardCrawl.CardType.FLAIL ||
            card.cardData.uiData.performedAction === CardCrawl.CardType.EXCHANGE ||
            card.cardData.uiData.performedAction === CardCrawl.CardType.VANISH
            ) {

            FX.goBackToDeck(card);

        } else if (
            card.cardData.uiData.performedAction === CardCrawl.ActionType.HIT || 
            card.cardData.uiData.performedAction === CardCrawl.CardType.LUCKY_SHOT ||
            card.cardData.uiData.performedAction === CardCrawl.CardType.BETRAYAL  ||
            card.cardData.uiData.performedAction === CardCrawl.CardType.KILLING_BLOW ||
            card.cardData.uiData.performedAction === CardCrawl.CardType.REFLECT
        ) {

            FX.hit(card, false, () => {

                card.scene.tweens.add({
                    targets: card,
                    alpha: 0,
                    scaleX: 1.1,
                    scaleY: 1.1,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: 500,
                    onComplete: () => {
                        card.destroy();
                    },
                    onCompleteScope: this
                });
                
            }, this);

        } else {

            const duration = 500;
            const delay = card.cardData.uiData.delay * FX.DELAY;
    
            card.scene.tweens.add({
                targets: card,
                alpha: 0,
                scaleX: 1.1,
                scaleY: 1.1,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: duration,
                delay: delay,
                onComplete: () => {
                    card.destroy();
                },
                onCompleteScope: this
            });
        }
    }

    public static flash(card: Card, onComplete?: () => void, onCompleteScope?: any): void {

        if (!card.scene) {
            return;
        }

        if (card.cardData.type === CardCrawl.CardType.ENEMY && onComplete) {
            onComplete.apply(onCompleteScope);
            return;
        }

        const flashImg = new Phaser.GameObjects.Image(card.scene, 0, 0, "texture_atlas_1", "card_silouette");
        flashImg.blendMode = Phaser.BlendModes.OVERLAY;
        card.add(flashImg);

        card.scene.tweens.add({
            targets: flashImg,
            alpha: 0,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 100,
            onComplete: () => {
                flashImg.destroy();
                if (onComplete) {
                    onComplete.apply(onCompleteScope);
                }
            },
            onCompleteScope: this
        });
    }

    public static changeValueLabel(card: Card): void {

        if (card.cardData.value === null || (card.cardData.lastValue === card.cardData.value && card.cardData.uiData.performedAction !== CardCrawl.ActionType.REVIVED)) {
            return;
        }

        let tmpValueLabel: Phaser.GameObjects.Text;

        let delay = 150;

        if (card.cardData.uiData.performedAction === CardCrawl.CardType.SWAP) {
            delay = 1500;
        }
        
        if (
            card.cardData.uiData.performedAction === CardCrawl.ActionType.HIT ||
            card.cardData.uiData.performedAction === CardCrawl.ActionType.REVIVED ||
            card.cardData.uiData.performedAction === CardCrawl.CardType.BETRAYAL ||
            card.cardData.uiData.performedAction === CardCrawl.CardType.LASH ||
            (card.cardData.uiData.performedAction === CardCrawl.CardType.REFLECT && card.cardData.type !== CardCrawl.CardType.PLAYER) ||
            card.cardData.uiData.performedAction === CardCrawl.CardType.SACRIFICE
        ) {
            delay = card.cardData.uiData.delay * FX.DELAY;
            FX.hit(card);
        }

        // PONER UN TEXTO CON EL VALOR QUE TIENE LA CARTA POR ENCIMA 
        // DE COLOR VERDE #00F44B O ROJO #FF154D Y HACERLO DESAPARECER POR ALPHA EN 0.5 s ease OUT
        card.scene.time.delayedCall(delay, () => {

            if (!card.scene) {
                return;
            }
  
            const colorFont = card.cardData.lastValue > card.cardData.value ? "#FF154D" : "#00F44B";

            const fontSize = card.valueLabel.style.fontSize;

            tmpValueLabel = new Phaser.GameObjects.Text(card.scene, card.valueLabel.x, card.valueLabel.y, card.cardData.lastValue.toString(), {fontFamily: "AlmendraBold", color: colorFont, fontSize: fontSize});
            tmpValueLabel.setOrigin(.5);
            card.valueLabel.parentContainer.add(tmpValueLabel);

            tmpValueLabel.setScale(1.1);
            card.valueLabel.setScale(1.1);

        }, [], this);

        card.scene.time.delayedCall(550 + delay, () => {

            if (!card.scene) {
                return;
            }
            
            tmpValueLabel.text = card.cardData.value.toString();
            card.valueLabel.text = card.cardData.value.toString();

            tmpValueLabel.setScale(1);
            card.valueLabel.setScale(1);

            card.scene.tweens.add({
                targets: tmpValueLabel,
                alpha: 0,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 350,
                delay: 500,
                onComplete: () => {
                    tmpValueLabel.destroy();
                },
                onCompleteScope: this
            });

        }, [], this);
    }

    public static hit(card: Card, goBackToDeck?: boolean, callback?: Function, callbackScope?: any): void {

        const delay = card.cardData.uiData.delay * FX.DELAY;

        card.scene.time.delayedCall(delay, () => {

            if (!card.scene) {
                return;
            }

            FX.flash(card);

            const deltaValue = card.cardData.lastValue - card.cardData.value;
            const shakeDuration = 100 + deltaValue * 50;
            const shakeIntensity = .002 + deltaValue * .001;

            card.scene.cameras.main.shake(shakeDuration, shakeIntensity);

            let chain: Phaser.Tweens.TweenChain;

            if (card.cardData.type === CardCrawl.CardType.PLAYER) {

                card.animatedItems.setScale(1.2); // Comienza con la carta agrandada

                chain = card.scene.tweens.chain({
                    targets: card.animatedItems,
                    tweens: [
                        {
                            scaleX: .9, // Primero, se reduce un poco
                            scaleY: .9,
                            ease: Phaser.Math.Easing.Cubic.Out,
                            duration: 300
                        },
                        {
                            scaleX: 1.1, // Luego, se agranda un poco para el efecto muelle
                            scaleY: 1.1,
                            ease: Phaser.Math.Easing.Cubic.Out,
                            duration: 200,
                        },
                        {
                            scaleX: 1, // Finalmente, se reduce al tamaño deseado
                            scaleY: 1,
                            ease: Phaser.Math.Easing.Cubic.Out,
                            duration: 100
                        }
                    ]
                });

            } else {

                card.animatedItems.setScale(.65);

                chain = card.scene.tweens.chain({
                    targets: card.animatedItems,
                    tweens: [
                        {
                            scaleX: 1.2,
                            scaleY: 1.2,
                            ease: Phaser.Math.Easing.Cubic.Out,
                            duration: 300
                        },
                        {
                            scaleX: .9,
                            scaleY: .9,
                            ease: Phaser.Math.Easing.Cubic.Out,
                            duration: 200,
                        },
                        {
                            scaleX: 1,
                            scaleY: 1,
                            ease: Phaser.Math.Easing.Cubic.Out,
                            duration: 100,
                            onComplete: () => {
        
                                    if (goBackToDeck) {
                                        FX.goBackToDeck(card);
                                    }
    
                                    if (callback) {
                                        callback.call(callbackScope);
                                    }
                                },
                            onCompleteScope: this
                        }
                    ]
                });
            }
            
            chain.play();

            let fxAnimationName: string;
            let scale = 1;
            let py = 0;

            if (card.cardData.type === CardCrawl.CardType.ENEMY && card.cardData.uiData.performedAction === CardCrawl.ActionType.HIT) {
                fxAnimationName = "flame_fx";
                scale = 1.5;
                py = -40;

                // PONER EL FX DE AUDIO QUE CORRESPONDA
                let spellFXKey: string;
                if (card.cardData.uiData.receivedDamage > 7) {
                    spellFXKey = "spell_3";
                } else if (card.cardData.uiData.receivedDamage > 4) {
                    spellFXKey = "spell_2";
                } else {
                    spellFXKey = "spell_1";
                }

                AudioManager.playSound(spellFXKey);

            } else {
                fxAnimationName = "slash_fx";
            }

            const fx = new Phaser.GameObjects.Sprite(card.scene, 0, py, "texture_atlas_1", "slash_fx_01");
            card.scene.add.existing(fx);
            fx.setScale(scale);
            fx.play(fxAnimationName);
            card.add(fx);

            let audioFXKey: string;

            switch (card.cardData.type) {
                case CardCrawl.CardType.SHIELD:
                    audioFXKey = "damage_on_shield";
                    break;
                case CardCrawl.CardType.PLAYER:
                    audioFXKey = "damage_on_hero";
                    break;
                default:
                    if (!(card.cardData.type === CardCrawl.CardType.ENEMY && card.cardData.uiData.performedAction === CardCrawl.ActionType.HIT))  {
                        audioFXKey = "damage_on_shield";
                    }
                    break;
            }

            if (audioFXKey) {
                AudioManager.playSound(audioFXKey);
            } 

        }, [], this);
    }

    public static showMessage(card: Card): void {

        const lan = GameVars.gameData.language;
        const text = GameVars.currentScene.cache.json.get("text");
        
        let labelStr: string;
        let delay = card.cardData.uiData.delay * FX.DELAY;
        let messageBackImageScaleX = 1;

        switch (card.cardData.uiData.performedAction) {

            case CardCrawl.ActionType.MISSED:

                delay = 250;

                labelStr = text.MESSAGE_MISSED[lan];
            
                break;
            
            case CardCrawl.ActionType.NO_CARD_FOUND:

                delay = 250;

                labelStr = text.MESSAGE_NO_CARD_FOUND[lan];
            
                break;
          
            case CardCrawl.CardType.LUCKY_SHOT:

                if (card.cardData.type === CardCrawl.CardType.PLAYER) { 
                    labelStr = text.MESSAGE_AIMING[lan];
                } else if (card.cardData.type !== CardCrawl.CardType.LUCKY_SHOT) {
                    labelStr = text.MESSAGE_REMOVE[lan];   
                }
                
                break;

            case CardCrawl.CardType.SWAP:

                delay = 250;
                labelStr = text.MESSAGE_SWAP[lan];
                
                break;

            case CardCrawl.CardType.STEAL:

                delay = 250;

                const previousState = GameVars.cardCrawlEngine.getPreviousState();

                if (previousState.lowerTableau[3] === null) {
                    labelStr = text.MESSAGE_STEAL[lan];
                } else {
                    labelStr = text.MESSAGE_MISSED[lan];
                }

                break;

            case CardCrawl.CardType.POTIONIZE:

                delay = 250;

                labelStr = text.MESSAGE_POTIONIZE[lan];
            
                break;

            case CardCrawl.CardType.REFLECT:

                if (card.cardData.type === CardCrawl.CardType.PLAYER) {
                    labelStr = text.MESSAGE_REFLECT[lan];
                } else if (card.cardData.value === null ) {
                    labelStr = text.MESSAGE_REMOVE[lan];
                } else {
                    messageBackImageScaleX = .4;
                    labelStr = (card.cardData.value - card.cardData.lastValue).toString();
                }

                break;

            case CardCrawl.CardType.LASH:

                if (card.cardData.type === CardCrawl.CardType.PLAYER) {
                    labelStr = text.MESSAGE_LASH[lan];
                } else {

                    messageBackImageScaleX = .4;
                    labelStr = "-3";
                }
                break;

            case CardCrawl.ActionType.HIT:
            case CardCrawl.ActionType.SHIELD_BASH:
            case CardCrawl.CardType.BETRAYAL:
            case CardCrawl.CardType.SACRIFICE:
            
                if (card.cardData.value === null ) {
                    labelStr = text.MESSAGE_REMOVE[lan];
                } else {
                    messageBackImageScaleX = .4;
                    labelStr = "-" + card.cardData.uiData.receivedDamage.toString();
                }

                break;

            case CardCrawl.CardType.VANISH:

                if (card.cardData.type === CardCrawl.CardType.PLAYER) {
                    labelStr = text.MESSAGE_VANISH[lan];
                } 
                break;

            case CardCrawl.CardType.LEECH:

                if (card.cardData.value === null) {
                    labelStr = text.MESSAGE_MISSED[lan];
                }

                break;
            
            case CardCrawl.CardType.REVIVE:

                labelStr = text.MESSAGE_REVIVE[lan];
                
                break;
            
            case CardCrawl.ActionType.REVIVED:

                labelStr = text.MESSAGE_REVIVED[lan];
                
                break;

            case CardCrawl.CardType.FLAIL:

                delay += FX.DELAY;

                labelStr = text.MESSAGE_FLAIL[lan];
                
                break;

            case CardCrawl.CardType.EXCHANGE:

                delay += FX.DELAY;

                labelStr = text.MESSAGE_EXCHANGE[lan];
                
                break;

            case CardCrawl.CardType.KILLING_BLOW:

                // ver la vida que tenia antes
                if (card.cardData.initialValue === card.cardData.value) {
                    labelStr = text.MESSAGE_MISSED[lan];
                } else {
                    messageBackImageScaleX = .4;
                    labelStr = "-" + card.cardData.uiData.receivedDamage.toString();
                }
                break;

            case CardCrawl.CardType.BASH:

                if (card.cardData.type === CardCrawl.CardType.PLAYER) {
                    // HAY UN ESCUDO EN LA OTRA MANO?
                    const state = GameVars.cardCrawlEngine.getState();

                    let isShield = false;

                    if (state.lowerTableau[0] && state.lowerTableau[0].type === CardCrawl.CardType.SHIELD) {
                        isShield = true;
                    }

                    if (state.lowerTableau[2] && state.lowerTableau[2].type === CardCrawl.CardType.SHIELD) {
                        isShield = true;
                    }

                    if (!isShield) {
                        labelStr = text.MESSAGE_MISSED[lan];
                    }

                } else {
                    labelStr = text.MESSAGE_BASH[lan];
                }

                break;

            default:
                labelStr = null;
        }

        let parent: Phaser.GameObjects.Container;

        if (card.cardData.tableau === CardCrawl.TableauType.UPPER) {
            parent = BoardContainer.currentInstance.upperTableauContainer;
        } else if (card.cardData.tableau === CardCrawl.TableauType.LOWER) {
            parent = BoardContainer.currentInstance.lowerTableauContainer;
        }

        if (labelStr && parent) { 

            const messageContainer = new Phaser.GameObjects.Container(card.scene, card.x, card.y);
            messageContainer.scale = 0;
    
            const messageBackground = new Phaser.GameObjects.Image(card.scene, 0, 0, "texture_atlas_1", "message_background");
            messageBackground.scaleX = messageBackImageScaleX;
            messageContainer.add(messageBackground);
    
            const messageLabel = new Phaser.GameObjects.Text(card.scene, 0, -5, labelStr, { fontFamily: "AlmendraBold", color: "#FFFFFF", fontSize: "36px" });
            messageLabel.setStroke("#900125", 6);
            messageLabel.setOrigin(.5);
            messageContainer.add(messageLabel);

            if (messageLabel.width > 145) {
                messageLabel.setScale(145 / messageLabel.width);
            }

            const chain = card.scene.tweens.chain({
                targets: messageContainer,
                tweens: [
                    {
                        scaleX: 1,
                        scaleY: 1,
                        ease: Phaser.Math.Easing.Cubic.Out,
                        duration: 350,
                        delay: delay,
                        onComplete: () => {
                            parent.add(messageContainer);
                        }, 
                        onCompleteScope: this
                    },
                    {
                        y: messageContainer.y + 20,
                        scaleX: .85,
                        scaleY: .85,
                        ease: Phaser.Math.Easing.Cubic.Out,
                        duration: 750
                    },
                    {
                        alpha: 0,
                        ease: Phaser.Math.Easing.Cubic.Out,
                        duration: 350,
                        onComplete: () => {
                            messageContainer.destroy();
                        },
                        onCompleteScope: this
                    }
                ]
            });
            chain.play();
        }
    } 

    public static pulse(card: Card): void {

        if (card.cardData.uiData.performedAction === CardCrawl.CardType.POTIONIZE) {

            card.scene.tweens.add({
                targets: card,
                scaleX: 1.05,
                scaleY: 1.05,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 150,
                yoyo: true
            });
        }
    }

    public static goBackToTableau(card: Card): void {

        if (card.cardData.uiData.performedAction === CardCrawl.ActionType.REFLECTED || card.cardData.uiData.performedAction === CardCrawl.ActionType.SHIELD_BASH) {

            card.x = GameVars.droppedCardPosition.x;
            card.y = GameVars.droppedCardPosition.y;
            card.angle = 0;
            
            BoardContainer.currentInstance.add(card);
            card.moveBackToTableau();

            AudioManager.playSound("card");
        }
    }

    public static goBackToDeck(card: Card): void {

        BoardContainer.currentInstance.add(card);

        card.y += BoardContainer.currentInstance.upperTableauContainer.y;

        const delay = card.cardData.uiData.delay * 200;

        // FLIP BACK
        card.scene.tweens.add({
            targets: card,
            scaleX: 0,
            scaleY: 1.15,   
            duration: 150,
            delay: delay,
            ease: Phaser.Math.Easing.Cubic.Out,
            onComplete: () => {

                if (card.animatedFrame) {
                    card.animatedFrame.visible = false;
                }

                if (card.valueLabel) {
                    card.valueLabel.visible = false;
                }

                if (card.nameLabel) {
                    card.nameLabel.visible = false;
                }

                card.img.setFrame("card_back");

                card.scene.tweens.add({
                    targets: card,
                    scaleX: 1,
                    scaleY: 1,   
                    duration: 200,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    onComplete: () => {
                            card.scene.tweens.add({
                            targets: card,
                            x: 0,
                            y: -350,
                            alpha: 0,
                            scaleX: .1,
                            scaleY: .1,
                            ease: Phaser.Math.Easing.Cubic.In,
                            duration: 350,
                            onComplete: () => {
                                card.destroy();
                                GameVars.eventsDispatcher.dispatchEvent(new CardCrawl.Event(EventType.CARD_RETURNED_TO_DECK, []));
                            },
                            onCompleteScope: this
                        });
                    },
                    onCompleteScope: this
                });
                
            },
            onCompleteScope: this
        });

        AudioManager.playSound("card");
    }

    public static setImgFrame(card: Card): void {

        switch (card.cardData.type) {

            case CardCrawl.CardType.POTION:
            case CardCrawl.CardType.SHIELD:
            case CardCrawl.CardType.GOLD:
            case CardCrawl.CardType.ENEMY:
                card.img.setFrame(Utils.getCardImageName(card.cardData.type, card.cardData.initialValue));     
                break;
            case CardCrawl.CardType.PLAYER:

                if (card.cardData.value === card.cardData.lastValue && !(card.cardData.uiData.performedAction === CardCrawl.ActionType.REVIVED)) {

                    card.img.setFrame(Utils.getCardImageName(card.cardData.type, card.cardData.value));   

                } else {

                    if (card.cardData.value < card.cardData.lastValue) {

                        card.img.setFrame(Utils.getCardImageName(card.cardData.type, card.cardData.lastValue));    
    
                        if (card.cardData.lastValue !== card.cardData.value) {
    
                            const delay = card.cardData.uiData.delay * FX.DELAY;
    
                            card.scene.time.delayedCall(delay, () => {

                                card.img.setFrame(Utils.getCardImageName(card.cardData.type, card.cardData.value));    

                                const heroFrameName = card.img.frame.name;
                                const heroFrameNumber = parseInt(heroFrameName.split("_")[1]);

                                switch (heroFrameNumber) {
                                    case 1:
                                        AudioManager.playSound("hero_state_2");
                                        break;
                                    case 2:
                                        AudioManager.playSound("hero_state_2");
                                        break;
                                    case 3:
                                        AudioManager.playSound("hero_state_3");
                                        break;
                                    case 4:
                                        AudioManager.playSound("hero_state_4");
                                        break;
                                    case 5:
                                        AudioManager.playSound("hero_state_5");
                                        break;
                                    default:
                                        break;
                                }

                            }, [], this);
                        }
    
                    } else {
                        // HACEMOS UNA TRANSICIÓN EN ALFA
                        card.img.setFrame(Utils.getCardImageName(card.cardData.type, card.cardData.value));    
    
                        let tmpImageName: string;

                        if (card.cardData.uiData.performedAction === CardCrawl.ActionType.REVIVED) {
                            tmpImageName = Utils.getCardImageName(card.cardData.type, 0);
                        } else {
                            tmpImageName = Utils.getCardImageName(card.cardData.type, card.cardData.lastValue);
                        }
                        
                        const tmpImg = new Phaser.GameObjects.Image(card.scene, 0, 0, "texture_atlas_2", tmpImageName);
                        card.animatedItems.add(tmpImg);
    
                        card.scene.tweens.add({
                            targets: tmpImg,
                            alpha: 0,
                            ease: Phaser.Math.Easing.Cubic.Out,
                            duration: 1500,
                            delay: 750,
                            onComplete: () => {
                                tmpImg.destroy();
                            },
                            onCompleteScope: this
                        });
                    }
                }

                break;
            default:
                card.img.setFrame(Utils.getCardImageName(card.cardData.type, card.cardData.value));    
        }
    }

    public static addCoinsHeartsEffect(card: Card, removeFromScene?: boolean): void {

        if (card.cardData.type === CardCrawl.CardType.PLAYER) {
            return;
        }

       if (card.cardData.uiData.performedAction === CardCrawl.ActionType.EMPTIED || card.cardData.uiData.performedAction === CardCrawl.ActionType.SELL_CARD) {

            card.scene.tweens.add({
                targets: card,
                alpha: .5,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 500
            });

            if (card.cardData.type === CardCrawl.CardType.POTION && card.cardData.uiData.performedAction === CardCrawl.ActionType.EMPTIED) {

                const heartEffect = new HeartEffect(card);
                heartEffect.x = card.x;
                heartEffect.y = card.y + BoardContainer.currentInstance.lowerTableauContainer.y;
                BoardContainer.currentInstance.add(heartEffect);

            } else if (card.cardData.uiData.performedAction === CardCrawl.ActionType.EMPTIED || (card.cardData.value !== null && card.cardData.type !== CardCrawl.CardType.GOLD)) {

                const coinsEffect = new CoinsEffect(card);
                coinsEffect.x = card.x;
                coinsEffect.y = card.y + BoardContainer.currentInstance.lowerTableauContainer.y;
                BoardContainer.currentInstance.add(coinsEffect);
            }
           
            if (removeFromScene) {

                const delay = card.cardData.uiData.performedAction === CardCrawl.ActionType.EMPTIED ? 1500 : 0;
                const duration = card.cardData.uiData.performedAction === CardCrawl.ActionType.EMPTIED ? 450 : 1500;

                card.scene.time.delayedCall(delay, function (): void {
    
                    card.scene.tweens.add({
                        targets: card,
                        alpha: 0,
                        scaleX: .6,
                        scaleY: .6,
                        ease: Phaser.Math.Easing.Cubic.Out,
                        duration: duration,
                        onComplete: () => {
                            card.destroy();
                        },
                        onCompleteScope: this
                    });
    
                }, [], this);
            }

        } else if (card.cardData.value === 0) {
                
            card.alpha = .5;
        }
    }

    public static audioFXCardDropped(card: Card, tableau: string, i?: number): void {

        const cardData: CardCrawl.CardData = card.cardData;

        // VER SI SE HA PUESTO EN LA MOCHILA
        if (tableau === CardCrawl.TableauType.LOWER ) {

            if (i === 0 || i === 2) {

                if (cardData.type === CardCrawl.CardType.SWORD) {
                    AudioManager.playSound("equip_spell");
                } else if (cardData.type === CardCrawl.CardType.POTION) {
                    AudioManager.playSound("equip_potion");
                } else if (cardData.type === CardCrawl.CardType.SHIELD) {
                    AudioManager.playSound("equip_shield");
                } else if (cardData.type === CardCrawl.CardType.GOLD) {
                    AudioManager.playSound("equip_treasure");
                } else if (cardData.special) {
                    AudioManager.playSound("equip_special");
                }

            } else if (i === 3) {

                if (cardData.type === CardCrawl.CardType.GOLD) {
                    AudioManager.playSound("equip_treasure");
                } else {
                    AudioManager.playSound("equip_backpack");
                }

            } else if (i === 1) {

                if (cardData.special) {
                    AudioManager.playSound("special_used");
                }
            }
            
        } else if (tableau === CardCrawl.TableauType.UPPER) {

            if (cardData.special) {
                AudioManager.playSound("special_used");
            }

        } else if (tableau === CardCrawl.TableauType.SHOP) {

            if (cardData.value && cardData.type !== CardCrawl.CardType.GOLD) {
                AudioManager.playSound("equip_treasure");
            } else {
                AudioManager.playSound("discard_treasure");
            }
        }
    }
}
